import React, { ChangeEvent, FC, useCallback } from 'react';
import { Switch } from '@mui/material';
import { OneOfPropertyElements } from '@shared/models/project.model';
import { IElementSwitchProperty } from '@shared/models/element-property.model';
import { useIsReadonly } from '@client/hooks/use-user.hooks';
import { getCount } from '@shared/helpers/element-property.helpers';
import { useUpdateProperty } from '@client/hooks/use-element-properties.hooks';

interface IElementPropertySwitchProps {
  property: IElementSwitchProperty;
  element: OneOfPropertyElements;
  readonly?: boolean;
}

const ElementPropertySwitch: FC<IElementPropertySwitchProps> = ({
  property,
  element,
  readonly: readonlyParam,
}) => {
  const count = getCount(property);

  const updateProperty = useUpdateProperty(element);

  const isReadonlyElement = useIsReadonly();
  const readonly = readonlyParam || isReadonlyElement || property.readonly;

  const savePropertyCount = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (typeof checked === 'boolean' && checked !== count) {
        updateProperty({ ...property, count: checked });
      }
    },
    [count, property, updateProperty],
  );

  return (
    <Switch
      disabled={readonly}
      size="small"
      checked={count}
      onChange={savePropertyCount}
    />
  );
};

export default ElementPropertySwitch;
